import useMediaQueries from 'app/hooks/useMediaQueries';
import { IProject, ProjectsTableResponse } from 'app/services/responseTypes';
import { CloudDownloadIcon } from 'assets/icons';
import Tooltip from 'Components/Tooltips';
import { Link } from 'react-router-dom';

interface IDownloadBtn {
  project: IProject;
}

const DownloadBtn = ({ project }: IDownloadBtn) => {
  const { md_down: isMobile } = useMediaQueries();

  return (
    <Link to={`${project.id.toString()}/download`}>
      {isMobile ? (
        <div className="text-sm px-4 w-full font-semibold bg-white text-black flex justify-start items-center h-10 lg:hidden">
          <div className="w-6 mr-2 flex justify-center">
            <CloudDownloadIcon className="text-green" />
          </div>
          <span>Download</span>
        </div>
      ) : (
        <Tooltip message="Download">
          <div className="border w-10 h-8 border-green rounded-lg hover:shadow-lg md-max:hidden flex items-center justify-center">
            <CloudDownloadIcon className="action-icon" />
          </div>
        </Tooltip>
      )}
    </Link>
  );
};

export default DownloadBtn;
